import { RiCloseCircleLine } from "@itandi/itandi-bb-ui";
import type React from "react";
import ReactModal from "react-modal";
import type { DealReportImage } from "~/models/DealReportImage";
import Styles from "./ImagePreviewModal.module.scss";

type Props = {
	handleClose: () => void;
	isOpen: boolean;
	reportImage: DealReportImage;
};

const customStyles = {
	content: {
		background: "none",
		border: "none",
		inset: 0,
		overflow: "auto",
		padding: "0",
		width: "100%"
	},
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		zIndex: 6
	}
};

ReactModal.setAppElement("body");

export const ImagePreviewModal: React.FC<Props> = ({
	isOpen,
	reportImage,
	handleClose
}: Props) => (
	<ReactModal
		isOpen={isOpen}
		onRequestClose={handleClose}
		shouldCloseOnOverlayClick // TODO: customStylesのせいで効かない
		style={customStyles}
	>
		<div className={Styles.ModalDialog}>
			<img alt="報告画像" className={Styles.Image} src={reportImage.imageUrl} />
			<div className={Styles.ModalClose}>
				<button
					className={Styles.ModalCloseButton}
					onClick={handleClose}
					type="button"
				>
					<RiCloseCircleLine className={Styles.CloseIcon} />
				</button>
			</div>
		</div>
	</ReactModal>
);
